/**
 * Created by saltrichter on 7/10/17.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var NotificationModel = {};

    var MS_PER_DAY = 1000 * 60 * 60 * 24;

    var KEYS = {
        TYPE: "type",
        SERVICE: "service",
        CRITICAL: "critical",
        INCIDENT_ID: "incidentID",
        SUPPORT_CASE: "support_case",
        START_DATE: "start_date",
        END_DATE: "end_date",
        IMPACT: "impact",
        STATUS: "status",
        INCIDENT_STATUS: "incidentStatus",
        ACTIVITY: "activity",
        USER_NAME: "userName",
        EXPIRATION_DATE: "expiration_date",
        USER_ID: "userId",
        SERVICE_IMPACTED: 'service_impacted',
        ID: "id",
        TIME: "creationTimestamp",
        IS_READ: "isRead",
        REMINDERS: "reminders",
        IS_DELETED: "isDeleted",
        UNREAD_MESSAGES:  "unreadMessages",
        SKILL_NAME: "skillName",
        SUBSCRIBER: "sub"
    };

    var INTERNAL_KEYS = {
        ICON_TYPE: 'iconType',
        DESCRIPTION: 'description',
        TITLE: 'title',
        DETAILS: 'details',
        DETAILED_ICON_TYPE: 'detailedIconType',
        TIME_AGO_RECEIVED: 'timeAgoReceived'
    };

    var TYPES = {
        SERVICE_STATUS: "service-status",
        SERVICE_MAINTENANCE: "service-maintenance",
        PASSWORD_EXPIRATION: "password-expiration",
        UNREAD_MESSAGES: 'messaging-unread-messages'
    };

    var ICON_TYPES = {
        CRITICAL: 'critical-icon',
        NOT_CRITICAL: 'not-critical-icon',
        RESOLUTION: 'resolved-icon',
        MAINTENANCE: 'maintenance-icon'
    };

    var INCIDENT_STATUS_KEYS = {
        START: 'start',
        ONGOING: 'ongoing',
        RESOLUTION: 'resolution'
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        NotificationModel = BaseModel.extend({
            initialize: function (options) {
                LEConnection.logger.debug('NotificationModel.initialize: started initializing with ', options);

                this.setTimestamp(options[KEYS.TIME] || new Date().getTime());//init time
                this._setTimeAgoReceived();

                switch (options.type) {
                    case TYPES.SERVICE_MAINTENANCE:
                        this._createServiceMaintenanceModel();
                        break;
                    // case TYPES.SERVICE_STATUS:
                    //     this._createServiceStatusModel();
                    //     break;
                    case TYPES.PASSWORD_EXPIRATION:
                        this._createPasswordExpirationModel();
                        break;
                    case TYPES.UNREAD_MESSAGES:
                        this._createUnreadMessagesModel();
                        break;
                    default:
                        throw new Error('Notification Type not supported');
                }

                this._chooseIcon();
                LEConnection.logger.debug('NotificationModel.initialize: finished initializing.');
            },

            toPersistenceModel: function () {
                var attributes = _.clone(this.attributes);
                _.each(INTERNAL_KEYS, function (key) {
                    delete attributes[key];
                });
                return attributes;
            },

            hasInternalAttributeChanged: function () {
                var keyAttributes = _.values(KEYS);
                var hasInternalAttributeChanged = keyAttributes.some(function (attribute) {
                    return attribute in this.changed;
                }, this);
                return hasInternalAttributeChanged;
            },

            _createServiceMaintenanceModel: function () {
                var startDateString = this._createDateTimeString(this.get(KEYS.START_DATE), true);
                var endDateString = this._createDateTimeString(this.get(KEYS.END_DATE), true);
                var descriptionDateString = this._createDateTimeString(this.get(KEYS.START_DATE), false);

                var impactedServicesArray = this.getServiceImpacted().split(',');
                var detailsServiceListString = _.reduce(impactedServicesArray, function (string, service) {
                    return string += ('<li>' + _capitalize(service) + '</li>');
                }, '');

                var title = 'Future Maintenance';
                var description = 'Upcoming maintenance scheduled for ' + descriptionDateString + '.';

                var servicesList = '<ul>{servicesImpacted}</ul>';
                servicesList = servicesList.replace('{servicesImpacted}', detailsServiceListString);

                var detailedDescription = '';
                detailedDescription += '<b>Start Date</b>:&ensp;' + startDateString + '</br></br>';
                detailedDescription += '<b>End Date</b>:&emsp;' + endDateString + '</br></br>';

                detailedDescription += '<b>Impact</b>:&ensp;' + String(this.getImpact()) + '</br></br>';
                detailedDescription += '<b>Affected Services</b>: </br>' + servicesList + '</br>';

                detailedDescription += '<b>Maintenance Activity</b>:&ensp;' + String(this.getActivity()) + '</br></br>';
                detailedDescription += '<b>Activity ID</b>:&ensp;' + String(this.get(KEYS.SUPPORT_CASE)) + '</br></br>';

                this.setType(TYPES.SERVICE_MAINTENANCE);
                this.setTitle(title);
                this.setDescription(description);
                this.setDetails(detailedDescription);

                this._remindOfMaintenance();

                LEConnection.logger.debug('NotificationModel._createServiceMaintenanceModel: created service maintenance event.');
            },

            _remindOfMaintenance: function () {
                var startTimestamp = this.get(KEYS.START_DATE);
                var threeDaysFromNow = 3 * MS_PER_DAY + Date.now();
                var isStartingInThreeDays = startTimestamp <= threeDaysFromNow;
                var isReminderRemaining = this.get(KEYS.REMINDERS) >= 1;

                if (isStartingInThreeDays) {
                    if (isReminderRemaining) {
                        this.setTimestamp(Date.now());
                        this._setTimeAgoReceived();

                        this.setItemUnread();
                        this.set(KEYS.IS_DELETED, false);
                        this.set(KEYS.REMINDERS, this.get(KEYS.REMINDERS) - 1);
                    }
                } else {
                    var diff = startTimestamp - threeDaysFromNow;
                    if (diff < MS_PER_DAY) {
                        setTimeout(_.bind(this._remindOfMaintenance, this), diff);
                    }
                }
            },

            _createDateTimeString: function (date, includeTimeZone) {
                var dateObject = new Date(date);
                var dateStringFormattingOptions = {weekday: 'long', month: 'long', day: 'numeric'};
                var timeStringFormattingOptions = {hour: 'numeric', minute: 'numeric'};
                if (includeTimeZone) {
                    timeStringFormattingOptions.timeZoneName = 'short';
                }
                return (dateObject).toLocaleDateString('en-US', dateStringFormattingOptions) + ' at ' + (dateObject).toLocaleTimeString('en-US', timeStringFormattingOptions);
            },

            _createPasswordExpirationModel: function () {
                LEConnection.logger.debug('NotificationModel._createServiceMaintenanceModel: created password expiration notification.');

                var title = LE.translator.translate("LEConnection.notifications.password.title");

                var description = LE.translator.translate("LEConnection.notifications.password.description");
                var detailedDescription = LE.translator.translate("LEConnection.notifications.password.details");
                var expirationText = this._buildExpirationText();
                description = description.replace("{expiration}", expirationText);
                detailedDescription = detailedDescription.replace("{expiration}", expirationText);

                this.setType(TYPES.PASSWORD_EXPIRATION);
                this.setTitle(title);
                this.setDescription(description);
                this.setDetails(detailedDescription);
            },

            _createUnreadMessagesModel: function(){
                this.setType(TYPES.UNREAD_MESSAGES);
            },

            _buildExpirationText: function () {
                var daysUntilExpiration = this._calculateDaysUntilExpiration();

                var todayString = LE.translator.translate("LEConnection.notifications.password.expiration.today");
                var dayString = LE.translator.translate("LEConnection.notifications.password.expiration.day");
                var daysString = LE.translator.translate("LEConnection.notifications.password.expiration.days");

                var expirationText = (daysUntilExpiration > 1 ? daysString : daysUntilExpiration === 0 ? todayString : dayString);
                expirationText = expirationText.replace("{number}", daysUntilExpiration.toString());
                return expirationText;
            },

            _calculateDaysUntilExpiration: function () {
                var expirationDate = this.getExpirationDate();
                var currentDate = this.get(KEYS.TIME);
                LEConnection.logger.debug('NotificationModel._calculateDaysUntilExpiration: expirationTime ' + expirationDate + ' currentTime ' + currentDate);
                return Math.floor((expirationDate - currentDate) / MS_PER_DAY);
            },

            _chooseIcon: function () {
                var iconType = this.isCritical() ? ICON_TYPES.CRITICAL : ICON_TYPES.NOT_CRITICAL;
                if (this.getType() === TYPES.SERVICE_MAINTENANCE) {
                    iconType = ICON_TYPES.MAINTENANCE;
                }
                this.setIconType(iconType);
                // if (this.getIncidentStatus() === INCIDENT_STATUS_KEYS.RESOLUTION) {
                //     this.setIconType(ICON_TYPES.RESOLUTION);
                // }
            },

            markAsDeleted: function () {
                this.setItemRead(); // set the item as read, so we don't have a notification for a non visible item
                this.set(KEYS.IS_DELETED, true);
            },

            isDeleted: function () {
                return this.get(KEYS.IS_DELETED);
            },

            getTrackingTitle: function () {
                var trackingString = this.getType();
                if (this.isIncident()) {
                    return trackingString + '; id: ' + this.getIncidentId() + '; service: ' + this.getService() + '; ' + this.getIncidentStatus();
                }
                if (this.isPasswordExpiration()) {
                    return trackingString + '; expirationDate: ' + new Date(this.getExpirationDate()).toUTCString();
                }
                if (this.isMaintenance()) {
                    return trackingString + '; id: ' + this.getId() + '; service: ' + this.getService() + '; ';
                }
                return trackingString;
            },

            getServiceImpacted: function () {
                return this.get(KEYS.SERVICE_IMPACTED);
            },

            setTimestamp: function (date) {
                this.set(KEYS.TIME, date);
            },
            getTimestamp: function () {
                return this.get(KEYS.TIME);
            },
            setType: function (type) {
                this.set(KEYS.TYPE, type);
            },
            getType: function () {
                return this.get(KEYS.TYPE);
            },
            isCritical: function () {
                return this.get(KEYS.CRITICAL) === true;
            },
            setUserId: function (userId) {
                this.set(KEYS.USER_ID, userId);
            },
            setExpirationDate: function (expirationDate) {
                this.set(KEYS.EXPIRATION_DATE, expirationDate);
            },
            getExpirationDate: function () {
                return this.get(KEYS.EXPIRATION_DATE);
            },
            setUserName: function (userName) {
                this.set(KEYS.USER_NAME, userName);
            },
            setService: function (service) {
                this.set(KEYS.SERVICE, service);
            },
            getService: function () {
                return this.get(KEYS.SERVICE);
            },
            setImpact: function (impact) {
                this.set(KEYS.IMPACT, impact);
            },
            getImpact: function () {
                return this.get(KEYS.IMPACT);
            },
            setIncidentId: function (incidentId) {
                this.set(KEYS.INCIDENT_ID, incidentId);
            },
            getIncidentId: function () {
                return this.get(KEYS.INCIDENT_ID);
            },
            setStartDate: function (startDate) {
                this.set(KEYS.START_DATE, startDate);
            },
            setEndDate: function (endDate) {
                this.set(KEYS.END_DATE, endDate);
            },
            setStatus: function (status) {
                this.set(KEYS.STATUS, status);
            },
            getIncidentStatus: function () {
                return this.get(KEYS.INCIDENT_STATUS);
            },
            setSupportCase: function (supportCase) {
                this.set(KEYS.SUPPORT_CASE, supportCase);
            },
            getActivity: function () {
                return this.get(KEYS.ACTIVITY);
            },
            setActivity: function (activity) {
                this.set(KEYS.ACTIVITY, activity);
            },
            setIconType: function (icontype) {
                this.set(INTERNAL_KEYS.ICON_TYPE, icontype);
            },
            getIconType: function () {
                return this.get(INTERNAL_KEYS.ICON_TYPE);
            },
            setDescription: function (description) {
                this.set(INTERNAL_KEYS.DESCRIPTION, description);
            },
            getDescription: function () {
                return this.get(INTERNAL_KEYS.DESCRIPTION);
            },
            setTitle: function (title) {
                this.set(INTERNAL_KEYS.TITLE, title);
            },
            getTitle: function () {
                return this.get(INTERNAL_KEYS.TITLE);
            },
            setDetails: function (id) {
                this.set(INTERNAL_KEYS.DETAILS, id);
            },
            getDetails: function () {
                return this.get(INTERNAL_KEYS.DETAILS);
            },
            setId: function (id) {
                this.set(KEYS.ID, id);
            },
            getId: function () {
                return this.get(KEYS.ID);
            },
            setItemRead: function () {
                this.set(KEYS.IS_READ, true);
            },
            setItemUnread: function () {
                this.set(KEYS.IS_READ, false);
            },
            isResolved: function () {
                return this.getIncidentStatus() === INCIDENT_STATUS_KEYS.RESOLUTION;
            },

            isRead: function () {
                return this.get(KEYS.IS_READ);
            },

            isIncident: function () {
                return this.getType() === TYPES.SERVICE_STATUS;
            },

            isMaintenance: function () {
                return this.getType() === TYPES.SERVICE_MAINTENANCE;
            },

            isPasswordExpiration: function () {
                return this.getType() === TYPES.PASSWORD_EXPIRATION;
            },

            isAccountLevelNotification: function () {
                return this.getType() === TYPES.SERVICE_MAINTENANCE;
            },

            isUserLevelNotification: function () {
                return this.getType() === TYPES.PASSWORD_EXPIRATION;
            },

            isForNotificationCenter: function () {
                return this.getType() !==  TYPES.UNREAD_MESSAGES;
            },

            isUnreadMessagesNotification: function () {
                return this.getType() === TYPES.UNREAD_MESSAGES;
            },

            isExpired: function () {
                var currentTime = new Date().getTime();
                if (this.isPasswordExpiration()) {
                    return currentTime > this.getExpirationDate();
                } else if (this.isMaintenance()) {
                    return currentTime > this.get(KEYS.END_DATE);
                }
                return false;
            },

            _setTimeAgoReceived: function () {
                var timestamp = this.getTimestamp();
                var timeAgoString = this.computeTimeAgoString(timestamp);
                this.set(INTERNAL_KEYS.TIME_AGO_RECEIVED, timeAgoString);
                this._scheduleTimeAgoRefresh(this.computeTimeAgoValue(timestamp));
            },

            computeTimeAgoString: function (receiptTime) {
                var smallestTimeValue = this.computeTimeAgoValue(receiptTime);
                return Math.round(smallestTimeValue.timeValue) + ' ' + smallestTimeValue.timeUnitIndicator + ' ago';
            },

            _scheduleTimeAgoRefresh: function (receiptTime) {
                var difference = Math.ceil(receiptTime.timeValue) - receiptTime.timeValue; //round up, now take the difference
                var timeUntilUpdate = Math.round(difference * receiptTime.timeUnitInMs);
                setTimeout(_.bind(this._setTimeAgoReceived, this), timeUntilUpdate);
            },

            computeTimeAgoValue: function (receiptTime) {
                var timeDiff = new Date() - receiptTime;
                var timeUnit = 1000 * 60;
                var minutes = timeDiff / 1000 / 60;
                var hours = minutes / 60;
                var days = hours / 24;
                var weeks = days / 7;
                var months = days / 30;
                var years = months / 12;
                var timeIndicator = 'min';
                var timeValue = minutes;
                if (hours >= 1) {
                    timeValue = hours;
                    timeIndicator = 'h';
                    timeUnit = timeUnit * 60;
                }
                if (days >= 1) {
                    timeIndicator = 'd';
                    timeValue = days;
                    timeUnit = timeUnit * 24;
                }
                if (weeks >= 1) {
                    timeIndicator = 'w';
                    timeValue = weeks;
                    timeUnit = timeUnit * 7;
                }
                if (months >= 1) {
                    timeIndicator = 'm';
                    timeValue = months;
                    timeUnit = (timeUnit / 7) * 30;
                }
                if (years >= 1) {
                    timeIndicator = 'y';
                    timeValue = years;
                    timeUnit = (timeUnit / 30) * 365;
                }
                return {timeValue: timeValue, timeUnitIndicator: timeIndicator, timeUnitInMs: timeUnit};
            },

            getUnreadMessagesData: function () {
                return { skillName: this.get(KEYS.SKILL_NAME),
                    unreadMessages: this.get(KEYS.UNREAD_MESSAGES),
                    sub: this.get(KEYS.SUBSCRIBER)};
            }
        });
    });

    function _capitalize(service) {
        //use this , since the used underscore doesnt have the capitalized method yet :(
        return service.toLowerCase()
            .split(' ')
            .map(function (word) {
                if (word === "bi") {
                    return "BI";
                } else if (word === "apis") {
                    return "APIs";
                } else if (word === "and") {
                    return "and";
                } else {
                    return word[0].toUpperCase() + word.slice(1);
                }
            })
            .join(' ');
    }

    return NotificationModel;
});
